export default {
  state: () => ({
    MobNav: true, // Отображение мобильного меню
  }),
  getters: {
    getMobNav: (s) => s.MobNav,
  },
}
